module.exports = "https://cdn.redage.net/src/views/player/documets/ems/images/serial.png";